import script from "./OperatorApplicationConfigBuddyList.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperatorApplicationConfigBuddyList.vue?vue&type=script&lang=ts&setup=true"

import "./OperatorApplicationConfigBuddyList.vue?vue&type=style&index=0&id=f35bbf9e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f35bbf9e"]])

export default __exports__